// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"Contacts_contentContainer__2JLkM","sidenavContainer":"Contacts_sidenavContainer__fj4lF"};